import { render } from "./UserInputsView.vue?vue&type=template&id=0f3a8a8c"
import script from "./UserInputsView.vue?vue&type=script&lang=js"
export * from "./UserInputsView.vue?vue&type=script&lang=js"

import "./UserInputsView.vue?vue&type=style&index=0&id=0f3a8a8c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__